module.exports = __webpack_public_path__ + "img/licencias-especialistas.4e1ede7f.svg";